import { render } from "./SejourMedicalDetailsView.vue?vue&type=template&id=3bbd93b2"
import script from "./SejourMedicalDetailsView.vue?vue&type=script&lang=js"
export * from "./SejourMedicalDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__